import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CommonState } from "./common.state";

export const featureKey = 'common';

export const selectCommonState = createFeatureSelector<CommonState>(featureKey)

//ROAD Results
export const selectRoadResults = createSelector(
  selectCommonState,
  state => state.roadResult
)

export const selectRoadData = createSelector(
  selectRoadResults,
  state => state.data
)

export const selectRoadPage = createSelector(
  selectRoadResults,
  state => state.page
)

export const selectRoadTotal = createSelector(
  selectRoadResults,
  state => state.total
)

////// Bound //////
export const selectBoundResults = createSelector(
  selectCommonState,
  state => state.boundResult
)
export const selectBoundData = createSelector(
  selectBoundResults,
  state => state.data
)
export const selectBoundPage = createSelector(
  selectBoundResults,
  state => state.page
)
export const selectBoundTotal = createSelector(
  selectBoundResults,
  state => state.total
)

////// Zone //////
export const selectZoneResults = createSelector(
  selectCommonState,
  state => state.zoneResult
)
export const selectZoneData = createSelector(
  selectZoneResults,
  state => state.data
)
export const selectZonePage = createSelector(
  selectZoneResults,
  state => state.page
)
export const selectZoneTotal = createSelector(
  selectZoneResults,
  state => state.total
)

////// AssetCode //////
export const selectAssetCodeResults = createSelector(
  selectCommonState,
  state => state.assetCodeResult
)
export const selectAssetCodeData = createSelector(
  selectAssetCodeResults,
  state => state.data
)
export const selectAssetCodePage = createSelector(
  selectAssetCodeResults,
  state => state.page
)
export const selectAssetCodeTotal = createSelector(
  selectAssetCodeResults,
  state => state.total
)

////// AssetCodesGroupDistinct //////
export const selectAssetCodesGroupDistinctResults = createSelector(
  selectCommonState,
  state => state.assetCodesGroupDistinctResult
)
export const selectAssetCodesGroupDistinctData = createSelector(
  selectAssetCodesGroupDistinctResults,
  state => state.data
)
export const selectAssetCodesGroupDistinctPage = createSelector(
  selectAssetCodesGroupDistinctResults,
  state => state.page
)
export const selectAssetCodesGroupDistinctTotal = createSelector(
  selectAssetCodesGroupDistinctResults,
  state => state.total
)

////// Life Cycle Cost Analysis //////
export const selectLccaResults = createSelector(
  selectCommonState,
  state => state.lccaResult
)
export const selectLccaData = createSelector(
  selectLccaResults,
  state => state.data
)
export const selectLccaPage = createSelector(
  selectLccaResults,
  state => state.page
)
export const selectLccaTotal = createSelector(
  selectLccaResults,
  state => state.total
)

////// LccaPeriodical //////
export const selectLccaPeriodicalResults = createSelector(
  selectCommonState,
  state => state.lccaPeriodicalResult
)
export const selectLccaPeriodicalData = createSelector(
  selectLccaPeriodicalResults,
  state => state.data
)
export const selectLccaPeriodicalPage = createSelector(
  selectLccaPeriodicalResults,
  state => state.page
)
export const selectLccaPeriodicalTotal = createSelector(
  selectLccaPeriodicalResults,
  state => state.total
)

////// LccaTrigger //////
export const selectLccaTriggerResults = createSelector(
  selectCommonState,
  state => state.lccaTriggerResult
)
export const selectLccaTriggerData = createSelector(
  selectLccaTriggerResults,
  state => state.data
)
export const selectLccaTriggerPage = createSelector(
  selectLccaTriggerResults,
  state => state.page
)
export const selectLccaTriggerTotal = createSelector(
  selectLccaTriggerResults,
  state => state.total
)

////// LccaType //////
export const selectLccaTypeResults = createSelector(
  selectCommonState,
  state => state.lccaTypeResult
)
export const selectLccaTypeData = createSelector(
  selectLccaTypeResults,
  state => state.data
)
export const selectLccaTypePage = createSelector(
  selectLccaTypeResults,
  state => state.page
)
export const selectLccaTypeTotal = createSelector(
  selectLccaTypeResults,
  state => state.total
)

////// LccaUnit //////
export const selectLccaUnitResults = createSelector(
  selectCommonState,
  state => state.lccaUnitResult
)
export const selectLccaUnitData = createSelector(
  selectLccaUnitResults,
  state => state.data
)
export const selectLccaUnitPage = createSelector(
  selectLccaUnitResults,
  state => state.page
)
export const selectLccaUnitTotal = createSelector(
  selectLccaUnitResults,
  state => state.total
)